import { supabase } from '@/config/supabase'
import type { AuditLog, UUID } from '@/types/database'

export const auditService = {
    async list(filters?: { user_id?: UUID; entidade?: string }) {
        let query = supabase
            .schema('veicular_system')
            .from('veic_audit_logs')
            .select('*')
            .order('created_at', { ascending: false })
            .limit(100)

        if (filters?.user_id) query = query.eq('user_id', filters.user_id)
        if (filters?.entidade) query = query.eq('entidade', filters.entidade)

        const { data, error } = await query
        if (error) throw error
        return (data || []) as AuditLog[]
    },

    async getById(id: UUID) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_audit_logs')
            .select('*')
            .eq('id', id)
            .single()

        if (error) throw error
        return data as AuditLog
    }
}
